(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-home-bestsellers"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initBs(root) {
      if (root.dataset.tbsInit) return;
      root.dataset.tbsInit = '1';
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-tbs-chip]'));
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tbs-card]'));

      // Horizontal-scroll arrows: each appears only while the row can still scroll that way.
      var track = root.querySelector('[data-tbs-track]');
      var prev = root.querySelector('[data-tbs-prev]');
      var next = root.querySelector('[data-tbs-next]');
      // One card + the row's real gap (12px on phones, the desktop gap on computers).
      function stepPx() {
        var card = track && track.querySelector('[data-tbs-card]:not([hidden])');
        var gap = track ? parseFloat(getComputedStyle(track).columnGap) : NaN;
        if (isNaN(gap)) gap = 12;
        return card ? card.getBoundingClientRect().width + gap : (track ? track.clientWidth * 0.8 : 0);
      }
      // Phones hide an arrow that has nothing left to scroll; computers keep both arrows in the
      // title row and show the finished one dimmed - `disabled` also takes it out of the tab order.
      function updateNav() {
        if (!track) return;
        var max = track.scrollWidth - track.clientWidth - 2;
        var prevOff = track.scrollLeft <= 2;
        var nextOff = max <= 0 || track.scrollLeft >= max;
        // Keyboard users: an arrow switched off while it has focus would drop the focus to the page (the next
        // Tab would restart from the top), so the focus moves to the other arrow first.
        if (prev && prevOff && document.activeElement === prev && next && !nextOff) next.focus({ preventScroll: true });
        if (next && nextOff && document.activeElement === next && prev && !prevOff) prev.focus({ preventScroll: true });
        if (prev) { prev.hidden = prevOff; prev.disabled = prevOff; }
        if (next) { next.hidden = nextOff; next.disabled = nextOff; }
      }
      if (track) {
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -stepPx(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: stepPx(), behavior: 'smooth' }); });
        track.addEventListener('scroll', updateNav, { passive: true });
        window.addEventListener('resize', updateNav);
        updateNav();
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var key = chip.getAttribute('data-tbs-chip');
          chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
          cards.forEach(function (card) {
            var cat = card.getAttribute('data-tbs-cat') || '';
            card.hidden = key !== '__all__' && cat !== key;
          });
          if (track) { track.scrollLeft = 0; setTimeout(updateNav, 0); }
        });
      });
    }
    function initAll() { document.querySelectorAll('[data-tbs]').forEach(initBs); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-home-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCard(card) {
      var handle = card.querySelector('[data-thr-handle]');
      var after = card.querySelector('[data-thr-after]');
      var divider = card.querySelector('[data-thr-divider]');
      var compare = card.querySelector('[data-thr-compare]');
      if (!handle || !after || !divider || !compare) return;
      var pos = parseFloat(handle.getAttribute('aria-valuenow'));
      if (isNaN(pos)) pos = 50;
      function apply(v) {
        pos = Math.max(0, Math.min(100, v));
        after.style.clipPath = 'inset(0 0 0 ' + pos + '%)';
        // publish the position so the day chips can be wiped by the same edge
        card.style.setProperty('--thr-pos', pos + '%');
        divider.style.left = pos + '%';
        handle.setAttribute('aria-valuenow', Math.round(pos));
      }
      function fromClientX(x) {
        var r = compare.getBoundingClientRect();
        if (!r.width) return pos;
        return (x - r.left) / r.width * 100;
      }
      var dragging = false;
      handle.addEventListener('pointerdown', function (e) {
        dragging = true;
        try { handle.setPointerCapture(e.pointerId); } catch (err) {}
        e.preventDefault();
      });
      handle.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        apply(fromClientX(e.clientX));
        e.preventDefault();
      });
      function end(e) {
        if (!dragging) return;
        dragging = false;
        try { handle.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      handle.addEventListener('pointerup', end);
      handle.addEventListener('pointercancel', end);
      handle.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 10 : 2;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { apply(pos - step); e.preventDefault(); }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { apply(pos + step); e.preventDefault(); }
        else if (e.key === 'Home') { apply(0); e.preventDefault(); }
        else if (e.key === 'End') { apply(100); e.preventDefault(); }
      });
      card._thrApply = apply;
      apply(pos);
    }
    // One-time HINT: gently sweep the divider left/right so people see it is draggable.
    // Cancels the moment they grab the handle; skipped for reduced-motion.
    function hintSweep(card) {
      var handle = card.querySelector('[data-thr-handle]');
      var applyFn = card._thrApply;
      if (!handle || !applyFn) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var keys = [{ t: 0, v: 50 }, { t: 0.28, v: 30 }, { t: 0.60, v: 72 }, { t: 1, v: 50 }];
      var dur = 1600, start = null, cancelled = false;
      function cancel() { cancelled = true; }
      handle.addEventListener('pointerdown', cancel, { once: true });
      function frame(ts) {
        if (cancelled) return;
        if (start === null) start = ts;
        var f = Math.min(1, (ts - start) / dur);
        var v = 50;
        for (var i = 1; i < keys.length; i++) {
          if (f <= keys[i].t) { var a = keys[i - 1], b = keys[i], lf = (f - a.t) / (b.t - a.t); v = a.v + (b.v - a.v) * lf; break; }
        }
        applyFn(v);
        if (f < 1) requestAnimationFrame(frame);
        else { applyFn(50); handle.removeEventListener('pointerdown', cancel); }
      }
      requestAnimationFrame(frame);
    }
    function initSection(root) {
      if (root.dataset.thrInit) return;
      root.dataset.thrInit = '1';
      root.querySelectorAll('[data-thr-card]').forEach(initCard);
      // Run the hint on the FIRST card once it scrolls into view.
      var firstCard = root.querySelector('[data-thr-card]');
      if (firstCard && 'IntersectionObserver' in window) {
        var hio = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) { hio.disconnect(); hintSweep(firstCard); } });
        }, { threshold: 0.5 });
        hio.observe(firstCard);
      }
      var track = root.querySelector('[data-thr-track]');
      // Computer arrows (rendered from 4 cards; hidden on phones): one card per click, each disabled once there is
      // nothing further that way.
      var prevB = root.querySelector('[data-thr-prev]');
      var nextB = root.querySelector('[data-thr-next]');
      if (track) {
        var stepPx = function () {
          var c = track.querySelector('[data-thr-card]');
          var gap = parseFloat(getComputedStyle(track).columnGap);
          if (isNaN(gap)) gap = 16;
          return c ? c.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
        };
        var updateNav = function () {
          var max = track.scrollWidth - track.clientWidth - 2;
          // Is the row wider than the page? The computers stylesheet shows the arrows only then (4 cards fit a row
          // from 1200px wide, 3 below that). Phones never read this attribute.
          root.toggleAttribute('data-thr-over', max > 0);
          if (!prevB && !nextB) return;
          var prevOff = track.scrollLeft <= 2;
          var nextOff = max <= 0 || track.scrollLeft >= max;
          // Keyboard users: an arrow switched off while it has focus would drop the focus to the page (the next
          // Tab would restart from the top), so the focus moves to the other arrow first.
          if (prevB && prevOff && document.activeElement === prevB && nextB && !nextOff) nextB.focus({ preventScroll: true });
          if (nextB && nextOff && document.activeElement === nextB && prevB && !prevOff) prevB.focus({ preventScroll: true });
          if (prevB) prevB.disabled = prevOff;
          if (nextB) nextB.disabled = nextOff;
        };
        if (prevB) prevB.addEventListener('click', function () { track.scrollBy({ left: -stepPx(), behavior: 'smooth' }); });
        if (nextB) nextB.addEventListener('click', function () { track.scrollBy({ left: stepPx(), behavior: 'smooth' }); });
        track.addEventListener('scroll', updateNav, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(updateNav).observe(track);
        else window.addEventListener('resize', updateNav);
        updateNav();
      }
      var dots = Array.prototype.slice.call(root.querySelectorAll('.thr-dot'));
      if (track && dots.length > 1) {
        track.addEventListener('scroll', function () {
          var cards = track.querySelectorAll('[data-thr-card]');
          if (!cards.length) return;
          var step = cards[0].offsetWidth + 16;
          var i = Math.min(dots.length - 1, Math.round(track.scrollLeft / step));
          dots.forEach(function (d, j) { d.classList.toggle('is-active', i === j); });
        }, { passive: true });
      }
    }
    function initAll() { document.querySelectorAll('[data-thr]').forEach(initSection); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-manifesto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // The headline SIZE is now PURE CSS (font = a fraction of the column width) - no JS
    // measuring, so it can never flip tiny or huge on load. This script only runs the reveal.
    function init(sec) {
      if (sec.dataset.tmanInit) return;
      sec.dataset.tmanInit = '1';
      if (reduce) { sec.classList.add('tman-anim', 'is-in'); return; }
      sec.classList.add('tman-anim');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { sec.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0 });
      io.observe(sec);
    }
    function initAll() { document.querySelectorAll('[data-tman]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-marketplaces"] && !Shopify.designMode) return;
  try {
    
  /* Analytics hook: every marketplace click becomes GA4's `marketplace_click` (marketplace, link_location =
     product|store, product_handle), so leakage to Amazon / Flipkart can be set against on-site add-to-carts.
     Since 2026-09-30 it goes through the site's one tracking channel ('thero:track' -> assets/thero-analytics.js);
     the old window.dataLayer push reached no tag (0 events in GA4 over 28 days). No other behaviour - the link
     itself is a plain <a>. */
  (function () {
    if (window.__theroMarketplaceClicks) return;
    window.__theroMarketplaceClicks = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[data-thero-marketplace]') : null;
      if (!a) return;
      document.dispatchEvent(new CustomEvent('thero:track', { detail: { event: 'marketplace_click', params: {
        marketplace: a.getAttribute('data-thero-marketplace') || '',
        link_location: a.getAttribute('data-thero-marketplace-context') || '',
        product_handle: a.getAttribute('data-thero-product') || ''
      } } }));
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initMarquee(root) {
      if (root.dataset.thmqInit) return;
      var track = root.querySelector('[data-thmq-track]');
      if (!track) return;
      root.dataset.thmqInit = '1';

      // The markup carries exactly ONE set of phrases - remember it so re-layout is clean.
      var originalHTML = track.innerHTML;
      var speed = parseFloat(root.dataset.speed) || 70; // pixels per second

      function layout() {
        track.removeAttribute('data-thmq-ready');
        track.innerHTML = originalHTML;
        var setWidth = track.scrollWidth;
        if (!setWidth) return;
        // Clone the set until the track is at least ~2 viewports wide, so there is always
        // enough content on screen for a seamless wrap.
        var need = root.clientWidth * 2 + setWidth;
        var guard = 0;
        while (track.scrollWidth < need && guard < 60) {
          track.insertAdjacentHTML('beforeend', originalHTML);
          guard++;
        }
        // Scroll by EXACTLY one original-set width and time it from the px/sec speed, so
        // the loop is seamless (period == one set) and the pace is phrase-count-independent.
        track.style.setProperty('--thmq-shift', setWidth + 'px');
        track.style.setProperty('--thmq-dur', (setWidth / speed) + 's');
        track.setAttribute('data-thmq-ready', '1');
      }

      layout();

      var t;
      window.addEventListener('resize', function () {
        clearTimeout(t);
        t = setTimeout(layout, 200);
      });
    }
    function initAll() { document.querySelectorAll('[data-thmq]').forEach(initMarquee); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-pdp-atc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initAtc(root) {
      if (root.dataset.tatcInit) return;
      var sticky = root.querySelector('[data-tatc-sticky]');
      if (!sticky) return;
      root.dataset.tatcInit = '1';

      var inline = root.querySelector('[data-tatc-inline]');

      // With no inline button to watch, the bar is always shown.
      if (!inline) {
        sticky.classList.add('is-visible');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            sticky.classList.toggle('is-visible', !entry.isIntersecting);
          });
        },
        { threshold: 0 }
      );
      observer.observe(inline);
    }
    function initAll() { document.querySelectorAll('[data-tatc]').forEach(initAtc); initPacks(); runFlip(); }

    /* CHOOSE YOUR PACK (16 Oct 2026). A row only decides WHAT the page's Add to cart buttons add:
       - choosing a row marks it, shows its price in the floating bar / sticky bar, and tells the tracker (pack_select);
       - just before one of THIS product's Add to cart forms is sent (the floating bar, the computers button, the sticky
         bar, the on-page button), its single "id" is switched off and the pack's items[N][id] / items[N][quantity] are
         added - so assets/thero-cart.js sends the whole pack in its one /cart/add.js call and Shopify's automatic offers
         price it. This runs on WINDOW in the capture phase, i.e. before thero-cart.js reads the form (document,
         capture). Pack of 1 leaves the form exactly as it was. The floating bar is re-drawn after every cart change,
         so its price is re-applied on 'cart:update' and the form is re-filled on every send - never cached. */
    var PACK_FORMS = ['floating_bar', 'pdp_desktop', 'sticky_bar', 'pdp_buybox'];
    var packOriginal = new WeakMap();
    function packRoot() { return document.querySelector('[data-tpack]'); }
    function packChosen(r) { return r.querySelector('[data-tpack-opt].is-on') || r.querySelector('[data-tpack-opt]'); }
    function paintPackPrice() {
      var r = packRoot();
      if (!r) return;
      var opt = packChosen(r);
      if (!opt) return;
      var tpl = opt.querySelector('template[data-tpack-barprice]');
      var html = opt.getAttribute('data-type') === 'single' || !tpl ? null : tpl.innerHTML;
      document.querySelectorAll('.tcbar-prod-price, .tatc-sticky-price').forEach(function (el) {
        if (!packOriginal.has(el)) packOriginal.set(el, el.innerHTML);
        var want = html === null ? packOriginal.get(el) : html;
        if (el.innerHTML !== want) el.innerHTML = want;
      });
    }
    /* While a pack or combo row is chosen, this product's Add to cart buttons must ADD that pack - so the quantity
       selector (snippets/thero-qty-stepper.liquid) steps aside: assets/base.css shows it only in a form WITHOUT
       .is-pack. Re-applied after every bar redraw, because the floating bar's form is replaced each time. */
    function paintPackForms() {
      var r = packRoot();
      if (!r) return;
      var opt = packChosen(r);
      var isPack = !!opt && opt.getAttribute('data-type') !== 'single';
      var ids = (r.getAttribute('data-variants') || '').split(',');
      document.querySelectorAll('form[data-track-source]').forEach(function (f) {
        if (PACK_FORMS.indexOf(f.getAttribute('data-track-source')) === -1) return;
        var idIn = f.querySelector('input[name="id"]');
        if (!idIn || ids.indexOf(String(idIn.value)) === -1) return;
        if (f.classList.contains('is-pack') !== isPack) f.classList.toggle('is-pack', isPack);
      });
    }
    function choosePack(opt, byPerson) {
      var r = opt.closest('[data-tpack]');
      if (!r) return;
      r.querySelectorAll('[data-tpack-opt]').forEach(function (o) {
        var on = o === opt;
        o.classList.toggle('is-on', on);
        var radio = o.querySelector('.tpack-radio');
        if (radio) radio.checked = on;
      });
      paintPackPrice();
      paintPackForms();
      if (byPerson) {
        // the tracker queues it (assets/thero-analytics.js) - nothing is sent inside the tap
        // user.last_pack: GoKwik's purchase arrives without our event params, so this visitor label (GA4 "Last pack
        // chosen") is what ties a purchase to the pack picked - the same pattern as offer_state_seen
        document.dispatchEvent(new CustomEvent('thero:track', { detail: { user: { last_pack: opt.getAttribute('data-id') }, event: 'pack_select', params: {
          pack_type: opt.getAttribute('data-id'),
          pack_units: parseInt(opt.getAttribute('data-pack-units'), 10) || 1,
          value: (parseInt(opt.getAttribute('data-price'), 10) || 0) / 100,
          product_handle: r.getAttribute('data-product-handle') || undefined
        } } }));
      }
    }
    /* THE COMBO VIEWER (29 Oct 2026): a combo's photos open a <dialog> with every product's photo + name and a
       "Choose this combo" button. Runs on DOCUMENT in the capture phase so a tap on the photos never reaches the row's
       own handlers (it only opens the viewer); taps are measured by the site tracker's ui_click (data-track-ui). */
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var open = t.closest('[data-tpack-view]');
      if (open) {
        e.preventDefault();
        e.stopPropagation();
        var dlg = document.getElementById(open.getAttribute('data-tpack-view'));
        if (dlg && dlg.showModal && !dlg.open) {
          dlg.showModal();
          // its own GA4 event (a tap inside a pack row is otherwise left to pack_select, which a look never fires)
          var vr = packRoot();
          document.dispatchEvent(new CustomEvent('thero:track', { detail: { event: 'combo_view_open', params: {
            pack_type: open.getAttribute('data-tpack-view-id'),
            pack_units: dlg.querySelectorAll('.tpack-view-item').length,
            product_handle: vr ? vr.getAttribute('data-product-handle') || undefined : undefined
          } } }));
        }
        return;
      }
      if (t.closest('[data-tpack-view-close]')) { var c = t.closest('dialog'); if (c) c.close(); return; }
      var pick = t.closest('[data-tpack-view-pick]');
      if (pick) {
        var pd = pick.closest('dialog');
        var r = packRoot();
        var opt = r ? r.querySelector('[data-tpack-opt][data-id="' + pick.getAttribute('data-tpack-view-pick') + '"]') : null;
        if (opt) choosePack(opt, true);
        if (pd) pd.close();
        return;
      }
      // a tap on the dark area around the viewer closes it
      if (t.matches && t.matches('dialog[data-tpack-view-dialog]')) t.close();
    }, true);

    function initPacks() {
      var r = packRoot();
      if (!r || r.dataset.tpackInit) return;
      r.dataset.tpackInit = '1';
      r.addEventListener('change', function (e) {
        var opt = e.target && e.target.closest ? e.target.closest('[data-tpack-opt]') : null;
        if (opt) choosePack(opt, true);
      });
      paintPackPrice();
      paintPackForms();
    }
    function refreshPackUi() { paintPackPrice(); paintPackForms(); runFlip(); }
    document.addEventListener('cart:update', function () {
      // the cart section has just re-drawn the floating bar: give it the chosen pack's price + form state again
      if (window.requestAnimationFrame) window.requestAnimationFrame(refreshPackUi); else refreshPackUi();
      settleBand();
    });
    document.addEventListener('thero:bar-swapped', function () { refreshPackUi(); settleBand(); });
    // A pack / combo went into the bag: go back to "Pack of 1", so the buttons show the quantity selector for what is
    // now in the bag instead of offering the same pack again.
    document.addEventListener('thero:cart-add', function (e) {
      var d = e.detail || {};
      if (!d.pack || d.pack === 'single') return;
      var r = packRoot();
      var single = r ? r.querySelector('[data-tpack-opt][data-type="single"]') : null;
      if (single) choosePack(single, false);
    });

    /* THE "BOUGHT" FLIP (16 Oct 2026, Shivam: "the xK+ bought and any offer unlocked thing are 2 stacking sticky
       things, can it flip ... whatever you think is better"). With the bag empty the band sits alone above the bar.
       Once the bar shows its dark offer strip, the band hides and a copy of it rides INSIDE the strip, taking turns
       with the offer line (offer ~4.5 s, bought ~3 s): one line of height instead of two stacked, nothing jumps, and
       both messages stay on screen. Paused while the offers sheet is open, the green "unlocked" banner plays, the
       strip is hovered or the tab is hidden; the bar is redrawn on every cart change, so the copy is re-installed. */
    var FLIP_MSG_MS = 4500;
    var FLIP_BOUGHT_MS = 3000;
    var flipTimer = null;
    var flipFor = null;
    function flipNudge() { return document.querySelector('.tcbar [data-tcbar-nudge]'); }
    function runFlip() {
      var band = document.querySelector('[data-tbought]');
      var nudge = flipNudge();
      if (!band || !nudge) { clearTimeout(flipTimer); flipFor = null; return; }
      if (flipFor === nudge) return;
      flipFor = nudge;
      if (!nudge.querySelector('.tbought-flip')) {
        var f = document.createElement('span');
        f.className = 'tbought-flip';
        f.setAttribute('aria-hidden', 'true');
        f.style.setProperty('--tb-accent', band.style.getPropertyValue('--tb-accent') || '#D65F17');
        Array.prototype.forEach.call(band.children, function (c) { f.appendChild(c.cloneNode(true)); });
        // before the green "unlocked" banner, so the banner still covers it
        nudge.insertBefore(f, nudge.querySelector('[data-tcbar-unlock]'));
        nudge.classList.add('has-bought');
      }
      clearTimeout(flipTimer);
      flipTimer = setTimeout(function step() {
        var n = flipNudge();
        if (n !== flipFor) return;
        var bar = n.closest('.tcbar');
        var paused = document.hidden || (bar && (bar.classList.contains('is-open') || bar.classList.contains('is-celebrating'))) || n.matches(':hover');
        if (paused) { flipTimer = setTimeout(step, 1200); return; }
        var showBought = !n.classList.contains('is-bought');
        n.classList.toggle('is-bought', showBought);
        flipTimer = setTimeout(step, showBought ? FLIP_BOUGHT_MS : FLIP_MSG_MS);
      }, FLIP_MSG_MS);
    }

    /* THE "BOUGHT" BAND: sits exactly on top of the floating cart bar (.tcbar, drawn by the cart section) while that
       bar is on screen (assets/thero-cart.js marks <html class="thero-cartbar">); hidden while it is not, or while
       its offers sheet is open. The bar slides in (~0.3 s) and changes height (the "add 1 more" nudge), so the band
       is re-placed on every frame for 0.5 s after any change - no scroll listener, no layout reads on a tap. */
    function placeBand() {
      var band = document.querySelector('[data-tbought]');
      if (!band) return;
      var bar = document.querySelector('.tcbar');
      var on = document.documentElement.classList.contains('thero-cartbar') && bar && !bar.classList.contains('is-open');
      // the offer strip is on screen: the band rides inside it instead (THE "BOUGHT" FLIP above)
      if (!on || bar.querySelector('[data-tcbar-nudge]')) { band.hidden = true; return; }
      var br = bar.getBoundingClientRect();
      // a rounded bar (the dock on computers): the band takes its top corners and tucks its foot behind the bar's
      // rounded top, so no notch shows at either end; a square bar (phones) leaves this at 0
      var rad = Math.round(parseFloat(getComputedStyle(bar).borderTopLeftRadius) || 0);
      var fromBottom = Math.max(0, Math.round(window.innerHeight - br.top) - rad);
      band.style.setProperty('--tbought-b', fromBottom + 'px');
      band.style.borderRadius = rad ? rad + 'px ' + rad + 'px 0 0' : '';
      band.style.paddingBottom = rad ? (6 + rad) + 'px' : '';
      // the band takes the bar's own left edge + width: the phone screen, the centred column at 750-989px, the dock on
      // computers (16 Oct: it spanned the whole window over the 750-989px column - measured at 900px)
      band.style.left = Math.round(br.left) + 'px';
      band.style.width = Math.round(br.width) + 'px';
      band.style.right = 'auto';
      band.hidden = false;
    }
    var bandUntil = 0;
    function settleBand() {
      bandUntil = Date.now() + 500;
      (function frame() {
        placeBand();
        if (Date.now() < bandUntil && window.requestAnimationFrame) window.requestAnimationFrame(frame);
      })();
    }
    if ('MutationObserver' in window) {
      new MutationObserver(settleBand).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    }
    window.addEventListener('resize', settleBand);
    document.addEventListener('click', function (e) {
      // the bar's offers sheet opening / closing changes its height
      if (e.target && e.target.closest && e.target.closest('[data-tcbar-toggle], [data-tcbar-close]')) settleBand();
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', settleBand); else settleBand();
    window.addEventListener('load', settleBand);
    window.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (PACK_FORMS.indexOf(form.getAttribute('data-track-source')) === -1) return;
      var r = packRoot();
      if (!r) return;
      var idIn = form.querySelector('input[name="id"]');
      if (!idIn) return;
      if ((r.getAttribute('data-variants') || '').split(',').indexOf(String(idIn.value)) === -1) return;
      var opt = packChosen(r);
      form.querySelectorAll('[data-tpack-items]').forEach(function (n) { n.parentNode.removeChild(n); });
      form.removeAttribute('data-track-pack');
      if (!opt || opt.getAttribute('data-type') === 'single') { idIn.disabled = false; return; }
      var n = 0;
      (opt.getAttribute('data-items') || '').split(',').forEach(function (pair) {
        var p = pair.split(':');
        if (!p[0]) return;
        [['id', p[0]], ['quantity', p[1] || '1']].forEach(function (kv) {
          var inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = 'items[' + n + '][' + kv[0] + ']';
          inp.value = kv[1];
          inp.setAttribute('data-tpack-items', '');
          form.appendChild(inp);
        });
        n += 1;
      });
      if (n === 0) { idIn.disabled = false; return; }
      idIn.disabled = true;
      form.setAttribute('data-track-pack', opt.getAttribute('data-id'));
    }, true);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-pdp-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      var track = root.querySelector('[data-tpb-track]');
      var dotsWrap = root.querySelector('[data-tpb-dots]');
      if (!track || !dotsWrap || root.dataset.tpbInit) return;
      root.dataset.tpbInit = '1';
      var slides = Array.prototype.slice.call(track.querySelectorAll('[data-tpb-slide]'));
      var dots = Array.prototype.slice.call(dotsWrap.children);
      // Computers: the thumbnail rail (hidden on phones) drives the same track as the dots.
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tpb-thumb]'));
      // Scroll only the TRACK sideways - scrollIntoView could also move the page up or down.
      function goTo(i) {
        if (slides[i]) track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
      }
      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          if (slides[i]) slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        });
      });
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () { goTo(i); });
      });
      // Computers: the rail shows ~8 thumbnails; when the arrows reach a later photo, scroll the RAIL (never the
      // page) so its thumbnail stays in view. Phones hide the rail - it has no height there, so this does nothing.
      function keepThumbInView(t) {
        var rail = t.parentElement;
        if (!rail || rail.scrollHeight <= rail.clientHeight + 1) return;
        var r = t.getBoundingClientRect(), rr = rail.getBoundingClientRect();
        if (r.top < rr.top) rail.scrollBy({ top: r.top - rr.top - 4, behavior: 'smooth' });
        else if (r.bottom > rr.bottom) rail.scrollBy({ top: r.bottom - rr.bottom + 4, behavior: 'smooth' });
      }
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = slides.indexOf(entry.target);
              dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
              thumbs.forEach(function (t, i) {
                t.classList.toggle('is-active', i === idx);
                if (i === idx) { t.setAttribute('aria-current', 'true'); keepThumbInView(t); } else t.removeAttribute('aria-current');
              });
            }
          });
        },
        { root: track, threshold: 0.6 }
      );
      slides.forEach(function (s) { observer.observe(s); });

      // Swipe arrows: scroll one slide; each shows only while the gallery can scroll that way.
      var prevBtn = root.querySelector('[data-tpb-prev]');
      var nextBtn = root.querySelector('[data-tpb-next]');
      function updateNav() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prevBtn) prevBtn.hidden = track.scrollLeft <= 2;
        if (nextBtn) nextBtn.hidden = max <= 0 || track.scrollLeft >= max;
      }
      if (prevBtn) prevBtn.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
      if (nextBtn) nextBtn.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
      track.addEventListener('scroll', updateNav, { passive: true });
      window.addEventListener('resize', updateNav);
      updateNav();
    }

    // FIGHTS chips in one sideways row: the right-edge fade shows only while more chips are hidden to the right.
    // Read after the next paint (no layout read while the page is still being built).
    function initChips(root) {
      root.querySelectorAll('[data-tpb-chips]').forEach(function (row) {
        if (row.dataset.tpbChipsInit) return;
        row.dataset.tpbChipsInit = '1';
        var queued = false;
        function update() {
          queued = false;
          var max = row.scrollWidth - row.clientWidth;
          row.classList.toggle('is-end', max <= 2 || row.scrollLeft >= max - 2);
        }
        function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
        row.addEventListener('scroll', queue, { passive: true });
        window.addEventListener('resize', queue);
        queue();
      });
    }

    // "Complete routine" pill: shown only when the page has a combo row in "Choose your pack" (the pack picker lives in
    // sections/thero-pdp-atc.liquid), collapsed to its round icon after data-collapse seconds (0 = never), and a tap
    // scrolls to that row with room for the pinned header. The tap itself is tracked by assets/thero-analytics.js
    // (the button carries the promotion labels), so this handler only scrolls.
    // The target is the DEAREST combo row - the full regimen (Shivam 16 Oct: "the regimen one should be auto selected
    // after the scroll, the max price one"); the first combo row was the two-serum duo.
    function routineTarget() {
      var best = null;
      document.querySelectorAll('[data-tpack-opt][data-type="combo"]').forEach(function (o) {
        if (!best || (parseInt(o.getAttribute('data-price'), 10) || 0) > (parseInt(best.getAttribute('data-price'), 10) || 0)) best = o;
      });
      return best || document.querySelector('[data-tpack]');
    }
    // Page position without transforms (a reveal animation's translate would move getBoundingClientRect).
    function docTop(el) {
      var y = 0;
      for (var n = el; n; n = n.offsetParent) y += n.offsetTop;
      return y;
    }
    // "Complete routine" lands on the WHOLE pack picker, centred between the pinned header and the floating cart bar
    // (16 Oct, Shivam: "more than required is getting scrolled" - measured: the old jump put the routine row 23px under
    // the header and pushed "Choose your pack" + its first rows off the top). If the picker is taller than that space,
    // the routine row itself is centred instead.
    function scrollToRoutine(row) {
      var picker = row.closest('[data-tpack]') || row;
      var hdr = document.querySelector('#header-group > header.shopify-section, header.shopify-section');
      var topLimit = hdr ? Math.max(0, hdr.getBoundingClientRect().height) : 0;
      var bottomLimit = window.innerHeight;
      ['.tcbar', '[data-tbought]'].forEach(function (sel) {
        var el = document.querySelector(sel);
        if (!el || el.hidden) return;
        var r = el.getBoundingClientRect();
        if (r.height > 0 && r.top < bottomLimit && r.top > window.innerHeight / 2) bottomLimit = r.top;
      });
      var room = bottomLimit - topLimit;
      var box = picker.offsetHeight + 24 <= room ? picker : row;
      var top = docTop(box) - topLimit - Math.max(12, (room - box.offsetHeight) / 2);
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
      return reduce;
    }
    // After the scroll settles: choose the routine row (the pack picker's own change handler marks it, re-prices the
    // bar and tracks pack_select) and let its badge glow for a moment.
    function selectRoutine(row) {
      var radio = row.querySelector('.tpack-radio');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
      row.classList.remove('is-glow');
      void row.offsetWidth;   // restart the glow if it is already running
      row.classList.add('is-glow');
      clearTimeout(row._tpbGlow);
      row._tpbGlow = setTimeout(function () { row.classList.remove('is-glow'); }, 2700);
    }
    // Scroll so `el` sits 12px under the pinned header (measured: the header section is sticky, 60px on phones; the
    // --header-height variable exists only on computers). Shared by the pill and the rating chip.
    function scrollUnderHeader(el) {
      // NOT '#header-group' itself: it is display: contents (height 0), and it comes first in the page, so the old
      // 'header.shopify-section, #header-group' always fell back to the 70px guess (measured 16 Oct; the header is 59px)
      var hdr = document.querySelector('#header-group > header.shopify-section, header.shopify-section');
      var head = hdr ? hdr.getBoundingClientRect().height : 0;
      if (!head) head = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 70;
      var top = el.getBoundingClientRect().top + window.pageYOffset - head - 12;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(0, top), behavior: reduce ? 'auto' : 'smooth' });
    }
    // The rating chip is a plain #thero-reviews link (works without this script); with it, the jump stops under the
    // pinned header instead of hiding the reviews heading behind it.
    function initScore(root) {
      root.querySelectorAll('[data-tpb-score]').forEach(function (a) {
        if (a.dataset.tpbScoreInit) return;
        a.dataset.tpbScoreInit = '1';
        a.addEventListener('click', function (e) {
          var href = a.getAttribute('href') || '';
          if (href.charAt(0) !== '#') return;
          var t = document.getElementById(href.slice(1));
          if (!t) return;
          e.preventDefault();
          scrollUnderHeader(t);
          if (window.history && history.replaceState) history.replaceState(null, '', href);
        });
      });
    }
    function initRoutine(root) {
      var btn = root.querySelector('[data-tpb-routine]');
      if (!btn || btn.dataset.tpbRoutineInit) return;
      btn.dataset.tpbRoutineInit = '1';
      if (!routineTarget()) return;   // no combo row on this page: the pill stays hidden
      btn.hidden = false;
      requestAnimationFrame(function () {
        // Start from the pill's real width, so the collapse animates smoothly from what is on screen.
        btn.style.maxWidth = btn.scrollWidth + 'px';
        var secs = parseFloat(btn.dataset.collapse) || 0;
        if (secs > 0) {
          setTimeout(function () {
            btn.classList.add('is-collapsed');
            btn.style.maxWidth = btn.offsetHeight + 'px';   // a circle: as wide as it is tall
          }, secs * 1000);
        }
      });
      btn.addEventListener('click', function () {
        var t = routineTarget();
        if (!t) return;
        if (!t.matches('[data-tpack-opt]')) { scrollUnderHeader(t); return; }
        var instant = scrollToRoutine(t);
        var done = false;
        function settle() {
          if (done) return;
          done = true;
          window.removeEventListener('scrollend', settle);
          selectRoutine(t);
        }
        if (instant) { requestAnimationFrame(settle); return; }
        // scrollend (Chrome / Firefox) ends it the moment the scroll stops; the timer covers Safari and a jump that
        // needed no scroll at all.
        window.addEventListener('scrollend', settle);
        setTimeout(settle, 1100);
      });
    }

    // Public hook for the in-house reviews app (thero-judge-me):
    //   window.theroSetRating({ rating: 4.7, count: 1024 })   (optional: verified: 980)
    // Lets the App Embed widget refresh the summary after the metafield sync,
    // without the theme needing to know anything about the app.
    // The rating strip under the photos (data-tpb-score) also takes part: its number is rounded DOWN at its own
    // decimals, it stays hidden below its "Minimum reviews" setting, and its "N verified reviews" pill changes only
    // with a verified count (payload.verified) - the app's count is ALL ratings, and the word "verified" must never
    // sit on a number that is not.
    window.theroSetRating = function (payload) {
      if (!payload) return;
      document.querySelectorAll('[data-thero-rating]').forEach(function (el) {
        var scale = parseFloat(el.dataset.ratingScale) || 5;
        var rating = parseFloat(payload.rating);
        var count = payload.count;
        var isStrip = el.hasAttribute('data-tpb-score');
        if (!isNaN(rating)) {
          el.dataset.rating = rating;
          var fill = el.querySelector('[data-thero-star-fill]');
          if (fill) fill.style.width = (rating / scale) * 100 + '%';
          var a11y = el.querySelector('[data-thero-rating-a11y]');
          if (a11y) a11y.textContent = 'Rated ' + rating + ' out of ' + scale;
          var val = el.querySelector('[data-thero-rating-value]');
          if (val) {
            // Same as the Liquid: rounded down at 1 or 2 decimals; 2 decimals drop a trailing zero (4.80 -> 4.8).
            var f = parseInt(el.dataset.ratingFactor, 10) || 10;
            var s = (Math.floor(rating * f + 0.0001) / f).toFixed(f === 100 ? 2 : 1);
            if (f === 100) s = s.replace(/0$/, '');
            val.textContent = s;
          }
        }
        if (count !== undefined && count !== null) {
          el.dataset.ratingCount = count;
          var countEl = el.querySelector('[data-thero-rating-count]');
          if (countEl) countEl.textContent = count;
        }
        if (isStrip) {
          var pill = el.querySelector('[data-tpb-score-count]');
          var shown = el.dataset.countMode === 'verified' ? payload.verified : count;
          if (pill && shown !== undefined && shown !== null && !isNaN(parseInt(shown, 10))) pill.textContent = parseInt(shown, 10).toLocaleString('en-IN');
          var n = parseInt(el.dataset.ratingCount, 10) || 0;
          var min = parseInt(el.dataset.ratingMin, 10) || 0;
          el.hidden = !(n > 0 && n >= min && !isNaN(parseFloat(el.dataset.rating)));
          return;
        }
        if (!isNaN(rating) || count) el.removeAttribute('hidden');
      });
    };

    // Only slots explicitly marked 'respect' stop for reduced-motion users. Decorative
    // brand loops default to 'always' so they behave like a GIF and never stall mid-loop.
    function applyMotionPreference() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.querySelectorAll('video[data-thero-video]').forEach(function (v) {
        if (reduce && v.dataset.theroVideo === 'respect') {
          v.removeAttribute('autoplay');
          v.pause();
        } else if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    }

    function initAll() {
      document.querySelectorAll('[data-tpb]').forEach(initGallery);
      document.querySelectorAll('[data-tpb]').forEach(initChips);
      document.querySelectorAll('[data-tpb]').forEach(initRoutine);
      document.querySelectorAll('[data-tpb]').forEach(initScore);
      applyMotionPreference();
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-pdp-details"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // "Open on computers" (2026-09-24): on a computer (990px+, desktop layout switched on) each card opens or closes as
    // its block's "Open on computers" setting says (Description open, Other Details closed by default). Phones and
    // tablets never run this: below 990px Horizon's own "Open by default" logic (accordion-custom.js) stays in charge.
    // Runs after the accordion element is defined, because its connectedCallback sets the phone / tablet default first.
    var DESK = window.matchMedia('(min-width: 990px)');
    var LARGE = window.matchMedia('(min-width: 750px)');
    function isDesk() {
      return DESK.matches && document.documentElement.classList.contains('thero-desktop');
    }
    function apply(root) {
      var desk = isDesk();
      root.querySelectorAll('.tacc-item[data-tacc-open-desk]').forEach(function (item) {
        var det = item.querySelector('details');
        if (!det) return;
        if (desk) {
          det.open = item.dataset.taccOpenDesk === 'true';
          item.dataset.taccDesk = '1';
        } else if (item.dataset.taccDesk) {
          // a computer window made narrower than 990px: hand the card back to its phone / tablet default
          var acc = item.querySelector('accordion-custom');
          det.open = !!acc && acc.hasAttribute(LARGE.matches ? 'open-by-default-on-desktop' : 'open-by-default-on-mobile');
          delete item.dataset.taccDesk;
        }
      });
    }
    function applyAll() {
      document.querySelectorAll('[data-tacc]').forEach(apply);
    }
    function whenReady(fn) {
      if (window.customElements && !customElements.get('accordion-custom')) {
        customElements.whenDefined('accordion-custom').then(fn);
      } else {
        fn();
      }
    }
    function start() {
      if (isDesk()) whenReady(applyAll);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
    // Horizon resets the cards when the window crosses 750px; run after it so the computer state wins above 990px.
    DESK.addEventListener('change', function () { setTimeout(function () { whenReady(applyAll); }, 0); });
    document.addEventListener('shopify:section:load', function (e) {
      if (isDesk() && e.target) whenReady(function () { apply(e.target); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-pdp-experience"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Respect prefers-reduced-motion: decorative loops must not autoplay for users
    // who asked the OS to reduce motion. The poster still shows, so nothing is lost.
    function applyMotionPreference() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.querySelectorAll('video[data-thero-video]').forEach(function (v) {
        if (reduce && v.dataset.theroVideo === 'respect') {
          v.removeAttribute('autoplay');
          v.pause();
        } else if (v.paused) {
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyMotionPreference);
    } else {
      applyMotionPreference();
    }
    document.addEventListener('shopify:section:load', applyMotionPreference);
    if (window.matchMedia) {
      var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (mq.addEventListener) mq.addEventListener('change', applyMotionPreference);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-pdp-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BURST_MS = 780; // keep in step with the .is-bursting animation so the pop is seen
    function initIngredients(root) {
      if (root.dataset.tingInit) return;
      root.dataset.tingInit = '1';
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function openDialog(sel) {
        var dlg = root.querySelector(sel);
        if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      }

      root.querySelectorAll('[data-tbub]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var sel = btn.dataset.dialog;
          if (reduce) { openDialog(sel); return; }
          btn.classList.remove('is-reforming');
          btn.classList.add('is-bursting');
          setTimeout(function () { openDialog(sel); }, BURST_MS);
        });
      });

      root.querySelectorAll('.ting-seeall').forEach(function (btn) {
        btn.addEventListener('click', function () { openDialog(btn.dataset.dialog); });
      });

      root.querySelectorAll('.ting-dialog').forEach(function (dlg) {
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
        dlg.addEventListener('close', function () {
          root.querySelectorAll('.tbub.is-bursting').forEach(function (b) {
            b.classList.remove('is-bursting');
            b.classList.add('is-reforming');
            setTimeout(function () { b.classList.remove('is-reforming'); }, 520);
          });
        });
      });
      root.querySelectorAll('[data-dialog-close]').forEach(function (b) {
        b.addEventListener('click', function () { var d = b.closest('dialog'); if (d) d.close(); });
      });
    }
    function initAll() { document.querySelectorAll('.ting').forEach(initIngredients); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else { initAll(); }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-pdp-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCompare(root) {
      if (root.dataset.tresInit) return;
      var handle = root.querySelector('[data-tres-handle]');
      var frame = root.querySelector('.tres-frame');
      if (!handle || !frame) return;
      root.dataset.tresInit = '1';

      var pos = parseFloat(handle.getAttribute('aria-valuenow'));
      if (isNaN(pos)) pos = 50;

      function apply(v) {
        pos = Math.max(0, Math.min(100, v));
        frame.style.setProperty('--tres-pos', pos + '%');
        handle.setAttribute('aria-valuenow', Math.round(pos));
        handle.setAttribute('aria-valuetext', Math.round(pos) + '% revealed');
      }
      function fromClientX(clientX) {
        var r = frame.getBoundingClientRect();
        if (!r.width) return pos;
        return (clientX - r.left) / r.width * 100;
      }

      var dragging = false;
      handle.addEventListener('pointerdown', function (e) {
        dragging = true;
        handle.classList.add('is-dragging');
        try { handle.setPointerCapture(e.pointerId); } catch (err) {}
        e.preventDefault();
      });
      handle.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        apply(fromClientX(e.clientX));
        e.preventDefault();
      });
      function endDrag(e) {
        if (!dragging) return;
        dragging = false;
        handle.classList.remove('is-dragging');
        try { handle.releasePointerCapture(e.pointerId); } catch (err) {}
      }
      handle.addEventListener('pointerup', endDrag);
      handle.addEventListener('pointercancel', endDrag);

      handle.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 10 : 2;
        if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') { apply(pos - step); e.preventDefault(); }
        else if (e.key === 'ArrowRight' || e.key === 'ArrowUp') { apply(pos + step); e.preventDefault(); }
        else if (e.key === 'Home') { apply(0); e.preventDefault(); }
        else if (e.key === 'End') { apply(100); e.preventDefault(); }
      });

      apply(pos);
    }
    function initAll() { document.querySelectorAll('[data-tres-compare]').forEach(initCompare); }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (m) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m];
      });
    }
    function escBr(s) { return esc(s).replace(/\n/g, '<br>'); }
    function thousands(n) {
      n = parseInt(n, 10);
      if (isNaN(n)) return '0';
      return n.toLocaleString('en-IN');
    }
    function timeAgo(iso) {
      if (!iso) return '';
      var d = (Date.now() - new Date(iso).getTime()) / 86400000;
      if (!(d >= 0)) return '';
      function unit(n, w) { return n + ' ' + w + (n === 1 ? '' : 's') + ' ago'; }
      if (d < 1) return 'Today';
      if (d < 7) return unit(Math.floor(d), 'day');
      if (d < 30) return unit(Math.floor(d / 7), 'week');
      if (d < 365) return unit(Math.floor(d / 30), 'month');
      return unit(Math.floor(d / 365), 'year');
    }
    var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true" style="width:SZpx;height:SZpx;flex:0 0 auto;display:block"><path d="M10 1.6l2.55 5.17 5.7.83-4.13 4.02.98 5.68L10 14.9l-5.08 2.7.98-5.68L1.75 7.6l5.7-.83z" fill="currentColor"/></svg>';
    // The SAME partial-fill stars as snippets/thero-stars.liquid, for cards the app renders live.
    function stars(rating, size, fill) {
      var r = parseFloat(rating) || 0, pct = Math.max(0, Math.min(100, r * 20));
      var s = STAR.split('SZ').join(size || 15), five = s + s + s + s + s;
      return '<span class="tstars" style="position:relative;display:inline-flex;line-height:0;vertical-align:middle" role="img" aria-label="Rated ' + r + ' out of 5">'
        + '<span style="display:inline-flex;gap:2px;color:#D9DEE3">' + five + '</span>'
        + '<span style="display:inline-flex;gap:2px;color:' + (fill || 'var(--tpr-star)') + ';position:absolute;top:0;left:0;bottom:0;width:' + pct + '%;overflow:hidden;white-space:nowrap">' + five + '</span></span>';
    }
    function root() { return document.querySelector('[data-tpr-root]'); }
    function ds(k, fallback) { var r = root(); return (r && r.dataset[k]) || fallback || ''; }

    // ---- read more / read less (per visible card) ----
    function setupReadMore(rootEl, card) {
      if (card.dataset.tprClamped) return;
      var body = card.querySelector('[data-tpr-body]');
      if (!body || card.hidden) return;
      card.dataset.tprClamped = '1';
      body.classList.remove('is-clamped');
      var full = body.getAttribute('data-full') || body.textContent;
      var maxLines = parseInt(rootEl.dataset.clamp, 10) || 3;
      var moreLabel = rootEl.dataset.moreLabel || 'read more';
      var lessLabel = rootEl.dataset.lessLabel || 'read less';
      var lh = parseFloat(getComputedStyle(body).lineHeight) || 22;
      var maxH = lh * maxLines + 1;
      body.innerHTML = escBr(full);
      if (body.scrollHeight <= maxH) return;
      var moreBtn = ' <button type="button" class="tpr-more" data-tpr-more>' + esc(moreLabel) + '</button>';
      function collapse() {
        var words = full.split(/\s+/), lo = 1, hi = words.length;
        while (lo < hi) {
          var mid = Math.ceil((lo + hi) / 2);
          body.innerHTML = esc(words.slice(0, mid).join(' ')) + '…' + moreBtn;
          if (body.scrollHeight <= maxH) lo = mid; else hi = mid - 1;
        }
        body.innerHTML = esc(words.slice(0, lo).join(' ')) + '…' + moreBtn;
        body.querySelector('[data-tpr-more]').addEventListener('click', expand);
      }
      function expand() {
        body.innerHTML = escBr(full) + ' <button type="button" class="tpr-more" data-tpr-more>' + esc(lessLabel) + '</button>';
        body.querySelector('[data-tpr-more]').addEventListener('click', collapse);
      }
      collapse();
    }
    function clampAll() {
      var r = root(); if (!r) return;
      r.querySelectorAll('[data-tpr-card]').forEach(function (c) { if (!c.hidden) setupReadMore(r, c); });
    }
    // Fallback-only filtering of the server-rendered sample (the app filters server-side once live).
    function applyLocalFilter(r, key) {
      if (r.dataset.tprLive) return;
      r.querySelectorAll('[data-tpr-card]').forEach(function (c) {
        c.hidden = !(key === '__all__' || c.dataset.skin === key);
      });
      clampAll();
    }

    // ---- the primitives the reviews app renders through ----
    function cardHTML(rv) {
      var r = root(), d = r ? r.dataset : {};
      var name = rv.author_name || 'Anonymous';
      var initial = (name.trim().charAt(0) || '•').toUpperCase();
      var tags = '';
      if (rv.age_range) tags += '<span class="tpr-tag">' + esc(rv.age_range) + ' ' + esc(d.ageSuffix || 'Age') + '</span>';
      if (rv.skin_type) tags += '<span class="tpr-tag">' + esc(rv.skin_type) + ' ' + esc(d.skinSuffix || 'Skin') + '</span>';
      var media = '';
      (rv.media || []).forEach(function (m) {
        if (m.kind === 'video') {
          media += '<video class="tpr-cp-video" src="' + esc(m.url) + '" controls preload="none" playsinline></video>';
        } else {
          media += '<button type="button" class="tpr-cp-thumb" data-tpr-gallery-big="' + esc(m.url) + '" aria-label="View photo"><img src="' + esc(m.thumbnail || m.url) + '" alt="" loading="lazy" width="72" height="72"></button>';
        }
      });
      // Dates are OFF by default (Shivam 2026-09-10: every review read "Today" the day they were approved).
      var date = d.showDate === 'true' ? timeAgo(rv.published_at || rv.created_at) : '';
      var helpful = '';
      if (d.showHelpful !== 'false' && rv.id != null) {
        // The app's embed.js owns the vote: it bumps [data-tpr-helpful-n] and swaps
        // [data-tpr-helpful-label] to data-thanks-label after a successful POST.
        helpful = '<div class="tpr-card-foot"><button type="button" class="tpr-helpful" data-tpr-helpful data-track-ui="helpful" data-id="' + esc(rv.id) + '" data-thanks-label="' + esc(d.helpfulDoneLabel || 'Thanks') + '">'
          + '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M6 9v8H3V9h3zm2 8h6.6a2 2 0 0 0 1.96-1.6l1.1-5.5A2 2 0 0 0 15.7 7.5H12l.6-3.2A1.5 1.5 0 0 0 11.1 2.5L8 8v9z" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/></svg>'
          + '<span data-tpr-helpful-label>' + esc(d.helpfulLabel || 'Helpful') + '</span>'
          + '<span class="tpr-helpful-n" data-tpr-helpful-n>' + (rv.helpful_count ? thousands(rv.helpful_count) : '') + '</span></button></div>';
      }
      return '<article class="tpr-card" data-tpr-card data-skin="' + esc((rv.skin_type || '').toLowerCase().trim()) + '" data-review-id="' + esc(rv.id) + '">'
        + '<div class="tpr-card-top"><div class="tpr-card-stars">' + stars(rv.rating, 15) + '</div>' + (date ? '<span class="tpr-card-date">' + esc(date) + '</span>' : '') + '</div>'
        + '<div class="tpr-card-who"><span class="tpr-avatar" aria-hidden="true">' + esc(initial) + '</span>'
        + '<span class="tpr-card-author">' + esc(name) + (rv.location ? ', ' + esc(rv.location) : '') + '</span>'
        + (rv.verified ? '<span class="tpr-card-verified"><svg class="tpr-vbadge" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><circle cx="8" cy="8" r="8" fill="var(--tpr-verified)"/><path d="M4.6 8.25l2.15 2.15 4.65-4.65" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>' + esc(d.verifiedLabel || 'Verified Buyer') + '</span>' : '')
        + '</div>'
        + (tags ? '<div class="tpr-card-tags">' + tags + '</div>' : '')
        + (rv.title ? '<p class="tpr-card-title">' + esc(rv.title) + '</p>' : '')
        + '<p class="tpr-card-body" data-tpr-body data-full="' + esc(rv.body || '') + '">' + escBr(rv.body || '') + '</p>'
        + (media ? '<div class="tpr-card-photos">' + media + '</div>' : '')
        + (rv.reply_body ? '<div class="tpr-reply"><b>' + esc(d.replyName || 'THERŌ') + '</b>' + escBr(rv.reply_body) + '</div>' : '')
        + helpful
        + '</article>';
    }
    function renderList(reviews) {
      var r = root(); if (!r) return;
      var list = r.querySelector('[data-tpr-list]'); if (!list) return;
      r.dataset.tprLive = '1';
      list.innerHTML = (reviews || []).map(cardHTML).join('');
      list.querySelectorAll('[data-tpr-card]').forEach(function (c) { delete c.dataset.tprClamped; });
      clampAll();
    }
    // the pager is re-drawn when the list's width really changes (a phone turned sideways), so the number of
    // page buttons always matches the room
    var pagerOpts = null, pagerW = 0, pagerT = 0;
    window.addEventListener('resize', function () {
      clearTimeout(pagerT);
      pagerT = setTimeout(function () {
        var r = root(); var nav = r && r.querySelector('[data-tpr-pager]');
        if (!pagerOpts || !nav || nav.hidden || Math.abs(nav.clientWidth - pagerW) < 20) return;
        renderPager(pagerOpts);
      }, 150);
    });
    function renderPager(opts) {
      var r = root(); if (!r) return;
      var nav = r.querySelector('[data-tpr-pager]'); if (!nav) return;
      pagerOpts = opts;
      var page = Math.max(1, parseInt(opts && opts.page, 10) || 1);
      var pages = Math.max(1, parseInt(opts && opts.pages, 10) || 1);
      var onGo = opts && opts.onGo;
      nav.innerHTML = '';
      if (pages <= 1) { nav.hidden = true; return; }
      var d = r.dataset;
      function btn(label, target, cls, disabled, current) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'tpr-page' + (cls ? ' ' + cls : '') + (current ? ' is-current' : '');
        b.innerHTML = label;
        if (disabled) b.disabled = true;
        if (current) b.setAttribute('aria-current', 'page');
        if (target) b.setAttribute('aria-label', (d.pageLabel || 'Page') + ' ' + target);
        b.addEventListener('click', function () { if (!disabled && !current && typeof onGo === 'function') onGo(target); });
        return b;
      }
      var chevL = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M12 4l-6 6 6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var chevR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M8 4l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var prev = btn(chevL, page - 1, 'tpr-page--arrow', page <= 1, false);
      prev.setAttribute('aria-label', d.prevLabel || 'Previous page');
      nav.appendChild(prev);
      // Numbers around the current page, the first and last page always reachable - only as many items as fit
      // beside the two arrows (a "..." counts as one). 38px buttons + 6px gaps; 32px in a list under 300px.
      nav.hidden = false;
      var w = nav.clientWidth || 320;
      pagerW = w;
      var slots = Math.floor((w + 6) / (w < 300 ? 38 : 44)) - 2;
      slots = Math.max(5, Math.min(9, slots));
      var range = function (a, b) { var o = []; for (var k = a; k <= b; k++) o.push(k); return o; };
      var nums;
      if (pages <= slots) nums = range(1, pages);
      else {
        var inner = slots - 2, win = inner - 2;
        var lo = page - Math.floor((win - 1) / 2), hi = lo + win - 1;
        if (lo <= 3) nums = range(1, inner).concat(['gap', pages]);
        else if (hi >= pages - 2) nums = [1, 'gap'].concat(range(pages - inner + 1, pages));
        else nums = [1, 'gap'].concat(range(lo, hi), ['gap', pages]);
      }
      nums.forEach(function (n) {
        if (n === 'gap') { var g = document.createElement('span'); g.className = 'tpr-page-gap'; g.textContent = '…'; g.setAttribute('aria-hidden', 'true'); nav.appendChild(g); }
        else nav.appendChild(btn(String(n), n, '', false, n === page));
      });
      var next = btn(chevR, page + 1, 'tpr-page--arrow', page >= pages, false);
      next.setAttribute('aria-label', d.nextLabel || 'Next page');
      nav.appendChild(next);
      var status = document.createElement('span');
      status.className = 'tpr-pager-status';
      status.setAttribute('aria-live', 'polite');
      status.textContent = (d.pageLabel || 'Page') + ' ' + page + ' / ' + pages;
      nav.appendChild(status);
      nav.hidden = false;
    }
    // The strip's side arrows: each shows only while that direction has more photos; a tap scrolls
    // ~3 tiles. Re-run after every render (the strip may gain or lose overflow).
    function wireStripArrows(r) {
      var strip = r.querySelector('[data-tpr-photos-strip]');
      var prev = r.querySelector('[data-tpr-photos-prev]');
      var next = r.querySelector('[data-tpr-photos-next]');
      if (!strip || !prev || !next) return;
      function update() {
        var max = strip.scrollWidth - strip.clientWidth;
        prev.hidden = !(max > 4 && strip.scrollLeft > 4);
        next.hidden = !(max > 4 && strip.scrollLeft < max - 4);
      }
      if (!strip.dataset.tprArrows) {
        strip.dataset.tprArrows = '1';
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var step = function () { var t = strip.querySelector('.tpr-photo'); return t ? (t.getBoundingClientRect().width + 8) * 3 : 260; };
        prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
        next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
        strip.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
      }
      update();
      // images may still be loading (lazy) - measure again once they have
      setTimeout(update, 600);
    }
    function renderPhotos(photos) {
      var r = root(); if (!r) return;
      var wrap = r.querySelector('[data-tpr-photos]');
      var strip = r.querySelector('[data-tpr-photos-strip]');
      var grid = r.querySelector('[data-tpr-gallery-grid]');
      var list = (photos || []).filter(function (p) { return p && p.url; });
      var max = parseInt(r.dataset.photosMax, 10) || 12;
      if (strip) {
        strip.innerHTML = list.slice(0, max).map(function (p) {
          return '<button type="button" class="tpr-photo" data-tpr-gallery-big="' + esc(p.url) + '" aria-label="View customer photo"><img src="' + esc(p.thumbnail || p.url) + '" alt="" loading="lazy" width="84" height="84"></button>';
        }).join('');
      }
      if (grid) {
        grid.innerHTML = list.slice(0, 24).map(function (p) {
          return '<button type="button" class="tpr-gallery-thumb" data-tpr-gallery-big="' + esc(p.url) + '"><img src="' + esc(p.thumbnail || p.url) + '" alt="Customer photo" loading="lazy" width="140" height="140"></button>';
        }).join('');
      }
      if (wrap) wrap.hidden = list.length === 0 || r.dataset.showPhotos === 'false';
      wireStripArrows(r);
    }
    function setSummary(p) {
      if (!p) return;
      var r = root(); if (!r) return;
      function set(sel, val) { if (val === undefined || val === null) return; var el = r.querySelector(sel); if (el) el.textContent = val; }
      if (p.rating != null) {
        set('[data-tpr-avg]', p.rating);
        var fill = r.querySelector('[data-thero-star-fill]');
        if (fill) fill.style.width = Math.max(0, Math.min(100, parseFloat(p.rating) * 20)) + '%';
        var sum = r.querySelector('[data-thero-rating]');
        if (sum) sum.setAttribute('data-rating', p.rating);
      }
      // Same truth rule as the Liquid: "Verified Reviews" only when EVERY written review is verified.
      var verified = parseInt(p.verified_count, 10) || 0;
      var written = parseInt(p.reviews_count, 10) || parseInt(p.ratings_count, 10) || 0;
      var badge = r.querySelector('[data-tpr-verified-badge]');
      var d0 = r.dataset;
      if (verified > 0 && verified >= written) {
        set('[data-tpr-reviews-count]', thousands(verified));
        set('[data-tpr-reviews-word]', verified === 1 ? (d0.verifiedWordOne || 'Verified Review') : (d0.verifiedWord || 'Verified Reviews'));
        if (badge) badge.hidden = false;
      } else if (written > 0) {
        set('[data-tpr-reviews-count]', thousands(written));
        set('[data-tpr-reviews-word]', written === 1 ? (d0.reviewsWordOne || 'Review') : (d0.reviewsWord || 'Reviews'));
        if (badge) badge.hidden = true;
      }
      // The "rated for" phrase and the score rings are FIXED product content - the app's payload never touches them.
      if (window.theroSetRating && (p.rating != null || p.ratings_count != null)) {
        window.theroSetRating({ rating: p.rating, count: p.ratings_count });
      }
    }
    function scrollToList() {
      var r = root(); if (!r) return;
      var list = r.querySelector('[data-tpr-list]') || r;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      list.scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
    }

    window.theroReviewsUI = {
      summary: setSummary, card: cardHTML, list: renderList, pager: renderPager,
      photos: renderPhotos, clamp: clampAll, scrollToList: scrollToList, stars: stars
    };
    window.theroSetReviewSummary = setSummary; // older name, kept for the app

    // ---- wiring ----
    function initRoot(r) {
      if (r.dataset.tprInit) return;
      r.dataset.tprInit = '1';
      r.querySelectorAll('[data-tpr-body]').forEach(function (b) { b.classList.remove('is-clamped'); });

      var chips = Array.prototype.slice.call(r.querySelectorAll('[data-tpr-filter]'));
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          chips.forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-selected', 'false'); });
          chip.classList.add('is-active');
          chip.setAttribute('aria-selected', 'true');
          applyLocalFilter(r, chip.dataset.tprFilter);
        });
      });

      // The Rate button is the app's review modal (window.theroWriteReview). Placeholder href = no jump.
      r.querySelectorAll('[data-tpr-rate]').forEach(function (el) {
        el.addEventListener('click', function (e) {
          if (typeof window.theroWriteReview === 'function') { e.preventDefault(); window.theroWriteReview({ productId: r.dataset.productId }); return; }
          var href = el.getAttribute('href');
          if (!href || href === '#') e.preventDefault();
        });
      });

      // Gallery: strip thumbs / card thumbs / grid thumbs open the overlay; full size steps back.
      r.addEventListener('click', function (e) {
        var g = r.querySelector('[data-tpr-gallery]');
        if (!g) return;
        var t;
        if (e.target.closest('[data-tpr-gallery-close]')) {
          g.hidden = true;
        } else if ((t = e.target.closest('[data-tpr-gallery-big]'))) {
          var full = g.querySelector('[data-tpr-gallery-full]');
          var grid = g.querySelector('[data-tpr-gallery-grid]');
          g.hidden = false;
          if (full) { full.src = t.getAttribute('data-tpr-gallery-big'); full.hidden = false; }
          if (grid) grid.hidden = true;
        } else if (e.target.closest('[data-tpr-gallery-full]')) {
          var full2 = g.querySelector('[data-tpr-gallery-full]');
          var grid2 = g.querySelector('[data-tpr-gallery-grid]');
          if (full2) full2.hidden = true;
          if (grid2) grid2.hidden = false;
        } else if (e.target === g) {
          g.hidden = true;
        }
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key !== 'Escape') return;
        var g = r.querySelector('[data-tpr-gallery]');
        if (g && !g.hidden) g.hidden = true;
      });

      // Draw the rings in when they scroll into view.
      var attrs = r.querySelector('[data-tpr-attrs]');
      if (attrs) {
        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) { if (en.isIntersecting) { attrs.classList.add('is-drawn'); io.disconnect(); } });
          }, { threshold: 0.3 });
          io.observe(attrs);
        } else {
          attrs.classList.add('is-drawn');
        }
      }

      applyLocalFilter(r, '__all__');
      wireStripArrows(r);
      fitSide(r);
    }

    // Computers: the summary column (stars, rings, photos, Rate) sticks under the header only while it fits the
    // screen - a column taller than the screen would keep its own bottom (the Rate button) out of sight until the
    // end of the list. Phones: the column has no box (display: contents), so this never changes anything there.
    function fitSide(r) {
      var side = r.querySelector('[data-tpr-side]');
      if (!side || side.dataset.tprFit) return;
      side.dataset.tprFit = '1';
      function check() {
        var hh = parseFloat(getComputedStyle(side).getPropertyValue('--header-height')) || 72;
        var h = side.offsetHeight;
        side.classList.toggle('is-fit', h > 0 && h + hh + 48 <= window.innerHeight);
      }
      check();
      if ('ResizeObserver' in window) new ResizeObserver(check).observe(side);
      window.addEventListener('resize', check);
    }

    var _t;
    window.addEventListener('resize', function () {
      clearTimeout(_t);
      _t = setTimeout(function () {
        var r = root(); if (!r) return;
        r.querySelectorAll('[data-tpr-card]').forEach(function (c) { delete c.dataset.tprClamped; });
        clampAll();
      }, 200);
    });

    function initAll() { document.querySelectorAll('[data-tpr-root]').forEach(initRoot); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thero-pdp-why-men"] && !Shopify.designMode) return;
  try {
    
  /* Flip cards (sections/thero-pdp-why-men.liquid). One listener on the document, so it serves every instance and
     keeps working after the theme editor re-renders the section. The button turns every card over (one after
     another), a tap on a card turns that card; the button then reads "Show less -" only while EVERY card shows its
     details. The back face leaves / joins the accessibility tree with what is on screen (visibility, in the stylesheet);
     the button's aria-expanded follows one frame after the tap. */
  if (!window.__theroWhyMen) {
    window.__theroWhyMen = true;
    var twmStill = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var twmStep = 90;
    var twmCards = function (root) { return root.querySelectorAll('[data-twm-card]'); };
    /* Only CLASSES change in the tap: an aria-* attribute change restyles the whole page here (Horizon's
       :has([aria-expanded]) / :has([aria-hidden]) rules, ~53 ms on a 4x slowed phone vs ~1 ms for a class; measured
       2026-10-01). The back face leaves / joins the accessibility tree through visibility in the stylesheet. */
    var twmSet = function (card, on, delay) {
      card.style.setProperty('--twm-delay', delay + 'ms');
      card.classList.toggle('is-flipped', on);
      /* an open card is not counted again when it is tapped to close (assets/thero-analytics.js reads this first) */
      if (on) card.setAttribute('data-track-ignore', '');
      else card.removeAttribute('data-track-ignore');
    };
    var twmSync = function (root) {
      var list = twmCards(root);
      var all = list.length > 0;
      for (var i = 0; i < list.length; i++) {
        if (!list[i].classList.contains('is-flipped')) { all = false; break; }
      }
      var btn = root.querySelector('[data-twm-toggle]');
      if (!btn) return;
      /* the stylesheet shows "Show less -" while the button has is-open, "Show details +" otherwise */
      btn.classList.toggle('is-open', all);
      if (all) btn.setAttribute('data-track-ignore', '');
      else btn.removeAttribute('data-track-ignore');
      /* aria-expanded (what screen readers announce) follows after the next paint, and only when it changes, so the
         tap's visible response never waits for the whole-page restyle that attribute triggers */
      var want = all ? 'true' : 'false';
      if (btn.getAttribute('aria-expanded') !== want) {
        requestAnimationFrame(function () {
          setTimeout(function () { btn.setAttribute('aria-expanded', btn.classList.contains('is-open') ? 'true' : 'false'); }, 0);
        });
      }
    };
    /* FIRST-VIEW PEEK (2026-10-01, Shivam: "not visible that it's clickable ... it should flip once for 2-3 sec, then
       flip back"). When the card list has been well on screen for 1.2 s (the scroll reveal is over by then) the cards
       turn over one after another, stay for the editor's "Keep them turned for" (data-twm-peek, ms) and turn back.
       Once per page view per band; never with reduced motion; never once the shopper has tapped. A card the shopper
       taps during the peek is theirs (the peek leaves it); "Show details" cancels the peek outright. The peek turns
       cards through twmSet, never through a click, so GA4 never counts it as a tap - it sends one why_men_peek event
       instead. The button's label and aria-expanded are left alone during it (an aria change restyles the whole page
       here). In the theme editor it plays each time the section is selected, so the hold time can be judged. */
    var twmPeekHold = function (root) {
      var v = parseInt(root.getAttribute('data-twm-peek'), 10);
      return v > 0 ? v : 0;
    };
    var twmPeekState = function (root) {
      if (!root.__twmPeek) root.__twmPeek = { done: false, io: null, dwell: 0, back: 0 };
      return root.__twmPeek;
    };
    /* the shopper acted: no peek from now on; with cancelRunning a peek already playing turns nothing back either */
    var twmPeekStop = function (root, cancelRunning) {
      var st = root.__twmPeek;
      if (!st) return;
      st.done = true;
      if (st.dwell) { clearTimeout(st.dwell); st.dwell = 0; }
      if (st.io) { st.io.disconnect(); st.io = null; }
      if (cancelRunning && st.back) { clearTimeout(st.back); st.back = 0; }
    };
    var twmPeekRun = function (root) {
      var st = twmPeekState(root);
      var hold = twmPeekHold(root);
      var list = twmCards(root);
      if (st.back || !hold || !list.length || (twmStill && twmStill.matches)) return;
      for (var i = 0; i < list.length; i++) {
        if (list[i].classList.contains('is-flipped')) return;   /* the shopper got there first */
      }
      var turned = [];
      for (var j = 0; j < list.length; j++) {
        list[j].__twmMine = false;
        twmSet(list[j], true, j * twmStep);
        turned.push(list[j]);
      }
      /* the hold counts from the moment the LAST card has finished turning (0.62 s, the stylesheet's transition) */
      st.back = setTimeout(function () {
        st.back = 0;
        var k = 0;
        for (var m = 0; m < turned.length; m++) {
          if (turned[m].__twmMine || !turned[m].classList.contains('is-flipped')) continue;
          twmSet(turned[m], false, k * twmStep);
          k++;
        }
      }, (list.length - 1) * twmStep + 620 + hold);
      try {
        document.dispatchEvent(new CustomEvent('thero:track', { detail: { event: 'why_men_peek', params: {
          product_handle: root.getAttribute('data-twm-product') || undefined, card_count: list.length, hold_ms: hold } } }));
      } catch (e) { /* analytics must never break the band */ }
    };
    var twmPeekWatch = function (root) {
      if (!twmPeekHold(root) || (twmStill && twmStill.matches)) return;
      if (window.Shopify && window.Shopify.designMode) return;   /* the editor plays it on select instead */
      var st = twmPeekState(root);
      if (st.done || st.io) return;
      var listEl = root.querySelector('.twm-cards');
      if (!listEl || !('IntersectionObserver' in window)) return;
      st.io = new IntersectionObserver(function (entries) {
        var e = entries[entries.length - 1];
        var vh = window.innerHeight || 1;
        /* well on screen = most of the list, or (a list taller than half the screen) half the screen filled by it */
        var good = e.isIntersecting && (e.intersectionRatio >= 0.6 || e.intersectionRect.height >= vh * 0.5);
        if (good && !st.dwell && !st.done) {
          st.dwell = setTimeout(function () {
            st.dwell = 0;
            if (st.done) return;
            st.done = true;
            if (st.io) { st.io.disconnect(); st.io = null; }
            twmPeekRun(root);
          }, 1200);
        } else if (!good && st.dwell) {
          clearTimeout(st.dwell);
          st.dwell = 0;
        }
      }, { threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] });
      st.io.observe(listEl);
    };
    var twmPeekInit = function () {
      var roots = document.querySelectorAll('[data-twm][data-twm-peek]');
      for (var i = 0; i < roots.length; i++) twmPeekWatch(roots[i]);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', twmPeekInit);
    else twmPeekInit();
    document.addEventListener('shopify:section:load', twmPeekInit);
    document.addEventListener('shopify:section:select', function (event) {
      var sec = event.target;
      var root = sec && sec.querySelector ? sec.querySelector('[data-twm][data-twm-peek]') : null;
      if (root) twmPeekRun(root);
    });

    document.addEventListener('click', function (event) {
      var t = event.target;
      if (!t || !t.closest) return;
      var btn = t.closest('[data-twm-toggle]');
      var root;
      if (btn) {
        root = btn.closest('[data-twm]');
        if (!root) return;
        twmPeekStop(root, true);   /* the shopper takes every card over: the peek turns nothing back */
        var open = !btn.classList.contains('is-open');
        var list = twmCards(root);
        var still = !!(twmStill && twmStill.matches);
        for (var i = 0; i < list.length; i++) twmSet(list[i], open, still ? 0 : i * twmStep);
        twmSync(root);
        return;
      }
      var card = t.closest('[data-twm-card]');
      if (!card) return;
      root = card.closest('[data-twm]');
      if (!root) return;
      card.__twmMine = true;       /* a peek that is playing never turns back a card the shopper touched */
      twmPeekStop(root, false);
      twmSet(card, !card.classList.contains('is-flipped'), 0);
      twmSync(root);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
